<div class="toast-stacking">
    <!-- <div class="toast-container"> -->
        <div
            *ngIf="toast"
            class="mt-toast flex-row"
            [ngClass]="[
                toast && toast.config.class ? toast.config.class : '',
                showToast ? 'fade-in' : 'fade-out'
            ]"
        >
            <div
                *ngIf="toast && toast.config.closeOnClick"
                class="box-close"
                (click)="onClose()"
            >
                x
            </div>

            <div class="content flex-col">
                <div class="title">
                    {{ toast.title }}
                </div>

                <div class="body">
                    {{ toast.message }}
                </div>
            </div>
        </div>
    <!-- </div> -->
</div>
